import React, {PureComponent} from 'react';
import timeSince from '../timeSince';
import Avatar from '../widgets/Avatar';
import striptags from 'striptags';
import OptionsButton from '../widgets/OptionsButton';

class CommunityNotice extends PureComponent {
	constructor() {
		super();
		this.state = {
			newComment: '',
			expanded: false
		};

		this.changeNewComment = e => this.setState({newComment: e.target.value});
		this.addComment = () => {
			if (
				this.state.newComment &&
				this.state.newComment.trim() &&
				this.props.onAddComment &&
				this.props.sessionProvider &&
				this.props.sessionProvider.user
			) {
				const newComment = striptags(this.state.newComment.trim())
					.split('&nbsp;')
					.join('');
				this.setState({newComment: ''});
				this.props.onAddComment(this.props.uuid, this.props.sessionProvider.user.uuid, newComment);
			}
		};
		this.newCommentKeyPress = e => {
			if (e.key === 'Enter') this.addComment();
		};
		this.toggleExpansion = () => this.setState({expanded: !this.state.expanded});
		this.UUIDRegex = new RegExp(
			/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
		);
		this.linkRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;
		this.linkify = content => {
			let contentObjs = [];
			let match = this.linkRegex.exec(content);
			let prevStart = 0;

			while (match !== null) {
				if (match.index > prevStart) {
					contentObjs.push({
						type: 'text',
						content: content.slice(prevStart, match.index)
					});
				}
				contentObjs.push({type: 'link', content: match[0]});
				prevStart = prevStart + (match.index - prevStart) + match[0].length;

				match = this.linkRegex.exec(content);
			}

			if (contentObjs.length === 0) {
				contentObjs.push({type: 'text', content: content});
			} else if (prevStart !== content.length) {
				contentObjs.push({
					type: 'text',
					content: content.slice(prevStart, content.length)
				});
			}

			return contentObjs;
		};
		this.calcTitleSize = title => {
			if (title && title.length > 100) {
				return {fontSize: '125%'};
			} else if (title && title.length > 40) {
				return {fontSize: '150%'};
			} else {
				return {fontSize: '200%'};
			}
		};
	}

	render() {
		const {
			uuid,
			title,
			content,
			backgroundURL,
			userUuid,
			comments,
			membersByUUID,
			sessionProvider,
			sessionUserMembership,
			createdAt,
			removeNotice,
			editNotice,
			image
		} = this.props;
		const {expanded} = this.state;

		const isLarge = content && content.length > 256;

		const contentObj = content && this.linkify(content);

		const poster = membersByUUID[userUuid];
		if (!poster) return null;

		const isCreator =
			sessionProvider &&
			sessionProvider.user &&
			poster &&
			poster.user &&
			poster.user.uuid === sessionProvider.user.uuid;
		const isSiteAdmin = sessionProvider && sessionProvider.user && sessionProvider.user.admin;
		const isCommunityAdmin = sessionUserMembership && sessionUserMembership.admin;

		const bgImg = this.UUIDRegex.test(backgroundURL)
			? `/api/image/${backgroundURL}`
			: backgroundURL;
		const prevImg = image && image.preview; // local preview of image

		return (
			<article className="CommunityNoticesPage-notice">
				<header style={{backgroundImage: `url(${prevImg || bgImg})`}}>
					<div>
						<h2 style={this.calcTitleSize(title)}>{title}</h2>
						<div className="CommunityNoticesPage-time">
							{createdAt ? timeSince(new Date(Date.parse(createdAt))) : 'Just now'}
						</div>
						<Avatar className="CommunityNoticesPage-avatar" provider={poster} size={32} />
					</div>
				</header>
				<div className="CommunityNoticesPage-participants">
					<Avatar
						className="CommunityNoticesPage-avatar"
						key={userUuid}
						provider={poster}
						size={32}
					/>
					{comments &&
						comments
							.map(comment => comment.userUuid)
							.filter(
								(value, index, self) => poster.user.uuid !== value && self.indexOf(value) === index
							)
							.map(userUuid => {
								const member = membersByUUID[userUuid];

								return member && <Avatar key={userUuid} provider={member} size={32} />;
							})}
					<div className="CommunityNoticesPage-spacer" />

					{isCreator || isCommunityAdmin || isSiteAdmin ? (
						<OptionsButton
							className="CommunityProfilePage-photo-options"
							options={[
								{
									key: 'edit',
									icon: 'icon-mode_edit',
									label: 'Edit this notice',
									onSelect: () => editNotice(uuid)
								},
								{
									key: 'delete',
									icon: 'icon-delete',
									label: 'Remove this notice',
									onSelect: () => removeNotice(uuid)
								}
							].filter(o => o.key !== 'delete' || isCommunityAdmin || isSiteAdmin)}
						/>
					) : (
						undefined
					)}
					{/*<button>Count me in</button>*/}
				</div>
				<div
					className={`CommunityNoticesPage-description ${
						isLarge ? (expanded ? 'expanded' : '') : 'small'
					}`}>
					{contentObj &&
						contentObj.map(part =>
							part.type === 'link' ? (
								<a
									href={part.content[0] === 'h' ? part.content : 'http://' + part.content}
									target="_blank"
									rel="noopener noreferrer">
									{part.content}
								</a>
							) : (
								<span>{part.content}</span>
							)
						)}
					<button onClick={this.toggleExpansion}>
						<span className="CommunityNoticesPage-icon-expand_more icon" />
						{isLarge && <span>{expanded ? 'Read less' : 'Read more'}</span>}
					</button>
				</div>
				<div className="CommunityNoticesPage-conversation">
					<ol className="CommunityNoticesPage-messages">
						{comments &&
							comments.map(({userUuid, content}) => {
								const member = membersByUUID[userUuid];

								return (
									member && (
										<li key={`${userUuid}_${content}`}>
											<Avatar provider={member} size={32} />
											<div className="CommunityNoticesPage-content">{content}</div>
										</li>
									)
								);
							})}
					</ol>
					{sessionProvider && sessionUserMembership && sessionUserMembership.status === 'approved' && (
						<div className="CommunityNoticesPage-edit">
							<div className="CommunityNoticesPage-avatar me" />
							<Avatar provider={sessionProvider.provider} size={32} />
							<input
								type="text"
								onChange={this.changeNewComment}
								onKeyPress={this.newCommentKeyPress}
								value={this.state.newComment}
							/>
							<button onClick={this.addComment}>
								<span className="CommunityNoticesPage icon icon-send" />
							</button>
						</div>
					)}
				</div>
			</article>
		);
	}
}

export default CommunityNotice;



// WEBPACK FOOTER //
// ./src/community/CommunityNotice.js